import React from 'react';
import { IconAlertCircle } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';
import { useRestoreCartFromOrder } from '@src/features/cart';

import { ExpiredAlertDescription, ExpiredAlertHeader, ExpiredAlertRoot, ExpiredAlertText, RetryButton } from './styles';

type PixExpiredAlertProps = {
  orderId: string | undefined;
};

export const PixExpiredAlert = (props: PixExpiredAlertProps) => {
  const { orderId } = props;
  const { i18n } = useTranslate();

  const { restore, restoring } = useRestoreCartFromOrder();

  return (
    <ExpiredAlertRoot data-testid='pix-expired-alert'>
      <ExpiredAlertText>
        <ExpiredAlertHeader>
          <IconAlertCircle size={20} aria-hidden />
          {i18n('checkout_payment_pix_expired_title')}
        </ExpiredAlertHeader>

        <ExpiredAlertDescription>{i18n('checkout_payment_pix_expired_description')}</ExpiredAlertDescription>
      </ExpiredAlertText>

      {orderId ? (
        <RetryButton
          variant='slim'
          color='primary'
          disabled={restoring}
          loading={restoring}
          onClick={() => restore(orderId)}
        >
          {i18n('checkout_payment_pix_expired_retry')}
        </RetryButton>
      ) : null}
    </ExpiredAlertRoot>
  );
};

export default PixExpiredAlert;
